import React, { useEffect, useMemo, useState, useReducer, useContext, useRef } from "react";
import { BrowserRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import Flex from '@react-css/flex';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable'
import logo from "../../../assets/criterio-experts.png";
import logo_mc from "../../../assets/crt_mclarens.png";
import api from '../../../services/api';
import { Table } from '../../../components/Table';
import { TableGroup } from '../../../components/TableGroup';
import { TableFormAtividadeList } from '../../../components/TableFormAtividadeList';
import { ToggleSwitch } from "../../../components/ToggleSwitch";
import { CardTableGrupoOptions } from "../../../components/CardTableGrupoOptions";
import { CardTableAtividadesOptions } from "../../../components/CardTableAtividadesOptions";
import { useLocation } from "react-router-dom";
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { Footer } from "../../../components/Footer";
import { StldRow } from "../../../styled-components/StldRow.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { MobileContext } from "../../../contexts/MobileContext";
import { ModalTimeSheetDetalhes } from "../../../components/ModalTimeSheetDetalhes";
import { ModalDetails } from "../../../components/ModalDetails";
import { ModalTimesheetResumo } from "../../../components/ModalTimesheetResumo";
import { ModalTimesheetProBonoResumo } from "../../../components/ModalTimesheetProBonoResumo";
import { ModalTimesheetItemAtividadeHistorico } from "../../../components/ModalTimesheetItemAtividadeHistorico";
import { ModalTimeSheetHistorico } from "../../../components/ModalTimeSheetHistorico";
import { ModalNotifyHistorico } from "../../../components/ModalNotifyHistorico";
import { ModalTimesheetFinalizar } from "../../../components/ModalTimesheetFinalizar";
import { ModalEdit } from "../../../components/ModalEdit";
import { ModalCancel } from "../../../components/ModalCancel";
import { ModalNotify } from "../../../components/ModalNotify";
import { ModalTimer } from "../../../components/ModalTimer";
import { ModalBilling } from "../../../components/ModalBilling";
import { ModalMeritocracy } from "../../../components/ModalMeritocracy";
import { ModalReview } from "../../../components/ModalReview";
import { PartialSeguradora } from "../../../components/PartialSeguradora";
import { PartialCriterio } from "../../../components/PartialCriterio";
import { PartialTsDetalhado } from "../../../components/PartialTsDetalhado";
import { AcoesTimesheetDetalhes } from "../../../components/AcoesTimesheetDetalhes";
import { PartialSegurado } from "../../../components/PartialSegurado";
import { PendenciaDeAprovacao } from "../../../components/PendenciaDeAprovacao";
import TimeSheetDetalhesContext from "../../../contexts/TimeSheetDetalhesContext";
import UploadTimeSheet from "../../../components/UploadTimeSheet";
import "react-datepicker/dist/react-datepicker.css";
import 'font-awesome/css/font-awesome.min.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { getAtividades } from '../../../services/atividades';
import { getPeritos } from '../../../services/peritos';
import { dateFormat } from '../../../utils/dateFormatUtil';
import { ModalNovoGrupoAtividade } from "../../../components/ModalNovoGrupoAtividade";
import { ModalGrupoDeAtividadesCancel } from "../../../components/ModalGrupoDeAtividadesCancel";
import { ModalAprovacoesAprovar } from "../../../components/ModalAprovacoesAprovar";
import { ModalAprovacoesReprovar } from "../../../components/ModalAprovacoesReprovar";
import { ModalAprovacoesCancelar } from "../../../components/ModalAprovacoesCancelar";
import { ModalAprovacoesConcluir } from "../../../components/ModalAprovacoesConcluir";
import { ModalMesclarTimesheet } from "../../../components/ModalMesclarTimesheet";
import { ModalNotifyGrupo } from "../../../components/ModalNotifyGrupo";
import { ModalConfigurarPreco } from "../../../components/ModalConfigurarPreco";
import { ModalConfigurarDesconto } from "../../../components/ModalConfigurarDesconto";
import { ModalObservacao } from "../../../components/ModalObservacao";
import { ModalCancelamentoTS } from "../../../components/ModalCancelamentoTS";
import { ModalReverterTS } from "../../../components/ModalReverterTS";
import { ModalNotifyGrupoHistorico } from "../../../components/ModalNotifyGrupoHistorico";
import { ExportacaoTimsheetTemplate } from "../ExportacaoTimsheetTemplate";
import { ModalEsclarecimento } from "../../../components/ModalEsclarecimento";
import Swal from "sweetalert2";


const defaultTimesheetItemAtividade = {
    "atividade": {
        "idAtividade": 0,
        "atividadeNome": "",
        "descricao": ""
    },
    "perito": {
        "idPerito": 0,
        "peritoNome": ""
    },
    "statusAtividade": {
        "status": 0,
        "statusNome": ""
    },
    "lancamento": {
        "dataLancamento": "",
        "horaInicial": "",
        "horaFinal": "",
        "descontarRefeicao": false,
        "intervaloHoras": "00:00",
        "totalHoras": 0,
        "horasExecutadas": 0,
        "horasFaturadas": 0,
        "horasAdicionais": 0,
        "horasPerdas": 0,
        "horasAnalise": 0
    },
    "valores": {
        "valorTotalFaturado": 0,
        "valorTotalExecutado": 0
    }
};

const defaultTimesheet = {
    "disciplina": {
        "seguradoNome": ""
    },
    "cliente": {
        "clienteNome": ""
    },
    "segurado": {
        "seguradoNome": ""
    },
    "sinistro": {
        "local": "",
        "numeroApolice": "",
        "numeroSinistro": ""
    },
    "pericia": {
        "sigla": "",
        "liderPericia": "",
        "tipoSinistro": ""
    },
    "timesheet": {
        "numeroTimesheet": "",
        "dataTimesheet": "",
        "statusTimesheet": "",
        "totalHoras": "",
        "totalValor": ""
    },
    "block": {
        "uploadBlock": true,
        "groupBlock": true
    },
    "actions": {
        "idTimesheet": "",
        "details": true,
        "historic": true,
        "cancel": true,
        "finish": true,
        "revision": false,
        "approve": false,
        "opne": false,
        "export": false,
        "exportToCliente": false
    }
}

const defaultTimesheetAtividade = {
    "access": {
        "insert": true
    },
    "page": {
        "recordsTotal": 0
    },
    "itens": [
        {
            "idTimesheetItemAtividade": "",
            "idTimesheet": "",
            "peritoNome": "",
            "atividade": "",
            "descricao": "",
            "datalancamento": "",
            "periodoInicio": "",
            "periodoFim": "",
            "intervaloHoras": "",
            "baseHoras": 0,
            "totalValorFaturado": 0,
            "actions": {
                "idTimesheetItemAtividade": "",
                "edit": true,
                "delete": true,
                "notify": true,
                "historic": true
            }
        }
    ]
}

const defaultTimesheetGrupoAtividade = {
    itens: [{
        Key: '',
        perito: {
            nome: "Thiago Silva"
        },
        Value: [{
            "idTimesheetItemAtividade": "",
            "idTimesheet": "",
            "atividade": "",
            "descricao": "",
            "datalancamento": "",
            "periodoInicio": "",
            "periodoFim": "",
            "intervaloHoras": "",
            "baseHoras": 0,
            "totalValorFaturado": 0,
            "actions": {
                "idTimesheetItemAtividade": "",
                "edit": true,
                "delete": true,
                "notify": true,
                "historic": true
            }
        }]
    }]
}

const advanceTimesheetVisualizacaoTp = { name: 'visualizacaoTipo', label: 'Tabelas', status: false };
const advanceTimesheetVisualizacaoTpGrupo = { name: 'advanceTimesheet', label: 'Tabelas', status: false };
const advanceTimesheet = { name: 'advanceTimesheet', label: 'Exibir Cancelados?', status: false };
const advanceTimesheetGrupo = { name: 'advanceTimesheetGrupo', label: 'Exibir Cancelados?', status: false };
const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

const getTimesheetById = async (idTimesheet) => {
    let timesheet = null;
    try {
        const response = await api.get(`Timesheet/load/${idTimesheet}`, config);
        timesheet = response.data.data;
    } catch (err) { }
    return timesheet;
}

const getTimesheeResumotById = async (idTimesheet) => {
    let timesheet = null;
    try {
        const response = await api.get(`Timesheet/resumo/${idTimesheet}`, config);
        timesheet = response.data.data;
    } catch (err) { }
    return timesheet;
}

const getTimesheetAtividadeById = async (idTimesheet, status) => {
    let timesheetAtividade = null;
    let params = `isCancel=${status}`;
    try {
        const response = await api.get(`Timesheet/atividade/load/${idTimesheet}?${params}`, config);
        timesheetAtividade = response.data.data;
    } catch (err) { }
    return timesheetAtividade;
}

const getTimesheetItemAtividade = async (idTimesheetItemAtividade) => {

    let timesheetItemAtividade = null;
    try {
        const response = await api.get(`Timesheet/atividade/${idTimesheetItemAtividade}`, config);
        timesheetItemAtividade = response.data.data;
    } catch (err) { }
    return timesheetItemAtividade;
}

const getTimesheetGrupoAtividadeById = async (idTimesheet, status) => {
    let timesheetGrupoAtividade = null;
    let params = `isCancel=${status}`;
    try {
        const response = await api.get(`Timesheet/grupo/load/${idTimesheet}?${params}`, config);
        timesheetGrupoAtividade = response.data.data;
    } catch (err) { }
    return timesheetGrupoAtividade;
}

const getExportarTimeSheet = async (idTimesheet) => {
    let timesheet = null;
    try {
        const response = await api.get(`Timesheet/export/${idTimesheet}`, config);
        timesheet = response.data.data;
        var byteArray = new Uint8Array(timesheet.file.fileByte);
        var a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(new Blob([byteArray], { type: 'application/octet-stream' }));
        a.download = "LayoutTimeSheet.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } catch (err) { }
    return timesheet;
}

const getExportarLayout = async (idTimesheet) => {
    let timesheet = null;
    try {
        const response = await api.get(`Timesheet/layout/export/${idTimesheet}`, config);
        timesheet = response.data.data;
        var byteArray = new Uint8Array(timesheet.file.fileByte);
        var a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(new Blob([byteArray], { type: 'application/octet-stream' }));
        a.download = "Layout.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } catch (err) { }
    return timesheet;
}

const getTimesheetAtividadeGroup = async (idTimesheet, status) => {
    let timesheetAtividade = null;
    let params = `isCancel=${status}`;
    try {
        const response = await api.get(`Timesheet/atividade/groupby/${idTimesheet}?${params}`, config);
        timesheetAtividade = response.data.data.itens;
    } catch (err) { }
    return timesheetAtividade;
}

const getTimesheetAtividadeGroupResumo = async (idTimesheet, status) => {
    let timesheetAtividade = null;
    let params = `isCancel=${status}`;
    try {
        const response = await api.get(`Timesheet/atividade/groupby/resumo/${idTimesheet}?${params}`, config);
        timesheetAtividade = response.data.data.itens;
    } catch (err) { }
    return timesheetAtividade;
}

export const TimeSheetDetalhes = (props) => {
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    var [timesheetGrupoAtividade, setTimesheetGrupoAtividade] = useState(defaultTimesheetGrupoAtividade);
    var [colunas, setColumns] = useState([]);
    var [colunasGrupo, setColumns] = useState([]);
    var [colunasAtividadeList, setColunasAtividadeList] = useState([]);
    var [showGroup, setShowGroup] = useState(false);
    var [isDataAtividade, setIsDataAtividade] = useState(false);
    var [isDataGrupo, setIsDataGrupo] = useState(false);
    var [legendaGrupo, setLegendaGrupo] = useState("Tabelas");
    var [legendaAtividades, setLegendaAtividades] = useState("Tabelas");
    var [atividades, setAtividades] = useState([]);
    var [resumoAtividades, setResumoAtividades] = useState([]);
    var [resumoAtividadesModal, setResumoAtividadesModal] = useState([]);    
    var [idAtividade, setIdAtividade] = useState([]);
    var [atividade, setAtividade] = useState([]);
    var [descricao, setDescricao] = useState([]);
    var [uploadIsOpen, setUploadIsOpen] = useState(false);
    var [horaFinal, setHoraFinal] = useState([]);
    var [horaInicio, setHoraInicio] = useState([]);
    const [resumo, setResumo] = useState([]);
    const [peritosList, setPeritosList] = useState([]);
    const [peritosListFormatado, setPeritosListFormatado] = useState([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalEditIsOpen, setEditIsOpen] = useState(false);
    const [modalCancelIsOpen, setCancelIsOpen] = useState(false);
    const [modalDetailsIsOpen, setDetailsIsOpen] = useState(false);
    const [modalTimesheetIsOpen, setModalTimesheetIsOpen] = useState(false);
    const [modalConfigurarPreco, setModalConfigurarPreco] = useState(false);
    const [modalConfigurarDesconto, setModalConfigurarDesconto] = useState(false);
    const [modalObservacoes, setmodalObservacoes] = useState(false);
    const [modalCancelamentoTS, setmodalCancelamentoTS] = useState(false);
    const [modalItemAtividadeHistoricoTimesheetIsOpen, setModalItemAtividadeHistoricoTimesheetIsOpen] = useState(false);
    const [modalTimeSheetHistoricoIsOpen, setModalTimeSheetHistoricoIsOpen] = useState(false);
    const [modalTimeshetFinalizarIsOpen, setModalTimeshetFinalizarIsOpen] = useState(false);
    const [modalTimeshetReverterTSIsOpen, setModalTimeshetReverterTSIsOpen] = useState(false);
    const [modalNotifyIsOpen, setNotifyIsOpen] = useState(false);
    const [modalNotifyGrupoIsOpen, setNotifyGrupoIsOpen] = useState(false);
    const [modalNotifyHistoricoIsOpen, setModalNotifyHistoricoIsOpen] = useState(false);
    const [modalNotifyGrupoHistoricoIsOpen, setModalNotifyGrupoHistoricoIsOpen] = useState(false);
    const [modalTimerIsOpen, setTimerIsOpen] = useState(false);
    const [modalBillingIsOpen, setBillingIsOpen] = useState(false);
    const [modalTableFormAtividadeListIsOpen, setmodalTableFormAtividadeListIsOpen] = useState(false);
    const [modalMeritocracyIsOpen, setMeritocracyIsOpen] = useState(false);
    const [modalReviewIsOpen, setReviewIsOpen] = useState(false);
    const [modalNovoGrupoAtividadeIsOpen, setmodalNovoGrupoAtividadeIsOpen] = useState(false);
    const [modalGrupoAtividadeCancelIsOpen, setmodalGrupoAtividadeCancelIsOpen] = useState(false);
    const [selectedGrupoAtividade, setselectedGrupoAtividade] = useState({});
    const [selectedAtividade, setselectedAtividade] = useState({});
    const [finalizarResumo, setFinalizarResumo] = useState({});
    const [timesheetPrecificacao, setTimesheetPrecificacao] = useState(null);
    const [finalizarResumoAccess, setFinalizarResumoAccess] = useState({});
    const [timesheetDescontoComercial, setTimesheetDescontoComercial] = useState(null);
    let [showCanceledTimeSheet, setCanceledTimeSheet] = useState(false);
    const [modalAprovarIsOpen, setModalAprovarIsOpen] = useState(false);
    const [modalReprovarIsOpen, setModalReprovarIsOpen] = useState(false);
    const [modalCancelarIsOpen, setModalCancelarIsOpen] = useState(false);
    const [pendenciaDeAprovacao, setPendenciaDeAprovacao] = useState(false);
    const [modalConcluirIsOpen, setModalConcluirIsOpen] = useState(false);
    const [modalMesclarTimesheetIsOpen, setModalMesclarTimesheetIsOpen] = useState(false);
    const [modalEsclarecimentoIsOpen, setModalEsclarecimentoIsOpen] = useState(false);
    const [modalTimesheeProbonoResumotIsOpen, setModalTimesheeProbonoResumotIsOpen] = useState(false);
    const { timesheetItemAtividade, setTimesheetItemAtividade,
        idTimesheetItemAtividade, setIdTimesheetItemAtividade,
        timesheetAtividade, setTimesheetAtividade,
        valoresAtividades, setValoresAtividades,
        timesheet, setTimesheet,
        showAtividades, setShowAtividades, dataLancamento, setdataLancamento } = useContext(TimeSheetDetalhesContext);
    let location = useLocation();
    const history = useHistory();



    const mudarVisaoGrupo = (status) => {
        if (showGroup) {
            legendaGrupo = "Tabelas";
        }
        else {
            legendaGrupo = "Cards";
        }
        advanceTimesheetVisualizacaoTpGrupo.label = legendaGrupo;
        setLegendaGrupo(legendaGrupo);
        setShowGroup(!showGroup);
    };

    const mudarVisaoAtividades = (status) => {
        if (showAtividades) {
            legendaAtividades = "Tabelas";
        }
        else {
            legendaAtividades = "Cards";
        }
        advanceTimesheetVisualizacaoTp.label = legendaAtividades

        setLegendaAtividades(legendaAtividades);
        setShowAtividades(!showAtividades);
    };


    const setDefaultVisaoGrupo = () => {

        legendaGrupo = "Cards";
        advanceTimesheetVisualizacaoTpGrupo.label = legendaGrupo;
        setLegendaGrupo(legendaGrupo);
        setShowGroup(true);
    };

    const setDefaultVisaoAtividades = () => {

        legendaAtividades = "Cards";
        advanceTimesheetVisualizacaoTp.label = legendaAtividades
        setLegendaAtividades(legendaAtividades);
        setShowAtividades(true);
    };


    const getCardId = (id) => {
        let cardId = document.getElementById(id);
        if (cardId.getAttribute('class', 'card-menu-hide') === 'card-menu-hide') {
            cardId.removeAttribute('class', 'card-menu-hide');
            cardId.setAttribute('class', 'card-menu-show');
        }
        else {
            cardId.removeAttribute('class', 'card-menu-show');
            cardId.setAttribute('class', 'card-menu-hide');
        }
    };

    const openModal = () => {
        setIsOpen(true);
    };

    const openDetailsModal = () => {
        setDetailsIsOpen(true);
    };

    const openModalTimesheetIsOpen = () => {
        setModalTimesheetIsOpen(true);
    };

    const openModalConfigurarPrecoOpen = () => {
        setModalConfigurarPreco(true);
    };

    const openModalConfigurarDescontoOpen = () => {
        setModalConfigurarDesconto(true);
    };

    const openModalObservacoesOpen = () => {
        setmodalObservacoes(true);
    };

    const openModalCancelamentoTSOpen = () => {
        setmodalCancelamentoTS(true);
    };

    const openModalItemAtividadeTimesheetHistoricoIsOpen = (item) => {
        setselectedAtividade(item)
        setModalItemAtividadeHistoricoTimesheetIsOpen(true);
    };

    const openModalTimeSheetHistoricoIsOpen = (item) => {
        setModalTimeSheetHistoricoIsOpen(true);
    };

    const openModalTimesheetFinalizarIsOpen = () => {
        setModalTimeshetFinalizarIsOpen(true);
    };

    const openModalReverterTSOpen = () => {
        setModalTimeshetReverterTSIsOpen(true);
    };

    const openNotifyModal = async (item) => {
        setIdTimesheetItemAtividade(item);
        setNotifyIsOpen(true);
    };

    const openNotifyGrupoModal = async (item) => {
        setselectedGrupoAtividade(item);
        setIdTimesheetItemAtividade(item);
        setNotifyGrupoIsOpen(true);
    };

    const openNotifyHistoricoModal = async (item) => {
        setselectedAtividade(item);
        setModalNotifyHistoricoIsOpen(true);
    };

    const openNotifyGrupoHistoricoModal = async (item) => {
        setselectedGrupoAtividade(item?.Value[0]);
        setModalNotifyGrupoHistoricoIsOpen(true);
    };

    const openModalProbono = () => {
        setModalTimesheeProbonoResumotIsOpen(true);
    };

    const openEditModal = async (item) => {
        let timesheetItemAtividade = await getTimesheetItemAtividade(item.idTimesheetItemAtividade);
        setTimesheetItemAtividade(timesheetItemAtividade);
        setIdTimesheetItemAtividade(item.idTimesheetItemAtividade);
        atividade = timesheetItemAtividade.atividade;
        idAtividade = timesheetItemAtividade.idAtividade;
        setAtividade(atividade);
        setIdAtividade(idAtividade);
        descricao = timesheetItemAtividade.atividade.descricao;
        setDescricao(descricao);
        setdataLancamento(dateFormat(timesheetItemAtividade.lancamento.dataLancamento));
        horaFinal = timesheetItemAtividade.lancamento.horaFinal
        setHoraFinal(horaFinal);
        horaInicio = timesheetItemAtividade.lancamento.horaInicial;
        setHoraInicio(horaInicio);
        setEditIsOpen(true);
    };

    const openCancelModal = async (idTimesheetItemAtividade) => {
        let timesheetItemAtividade = await getTimesheetItemAtividade(idTimesheetItemAtividade);
        setTimesheetItemAtividade(timesheetItemAtividade);
        setIdTimesheetItemAtividade(idTimesheetItemAtividade);
        setCancelIsOpen(true);
    };

    const openTimerModal = () => {
        setTimerIsOpen(true);
    };

    const openBillingModal = () => {
        setBillingIsOpen(true);
    };

    const openMeritocracyModal = () => {
        setMeritocracyIsOpen(true);
    };

    const openReviewModal = () => {
        setReviewIsOpen(true);
    };

    const afterDetailsOpenModal = () => { };
    const afterNotifyOpenModal = () => { };
    const afterNotifyGrupoOpenModal = () => { };
    const afterEditOpenModal = () => { };
    const afterCancelOpenModal = () => { };
    const afterTimerOpenModal = () => { };
    const afterBillingOpenModal = () => { };
    const afterMeritocracyOpenModal = () => { };
    const afterReviewOpenModal = () => { };

    const closeDetailsModal = () => {
        setDetailsIsOpen(false);

    }

    const closeModalTimesheet = () => {
        setModalTimesheetIsOpen(false);
    }

    const closeModalProbono = () => {
        setModalTimesheeProbonoResumotIsOpen(false);
    }

    const closeModalConfigurarPreco = () => {
        setModalConfigurarPreco(false);
    }

    const closeModalConfigurarDesconto = () => {
        setModalConfigurarDesconto(false);
    }

    const closeModalObservacoes = () => {
        setmodalObservacoes(false);
    }

    const closeModalCancelamentoTS = () => {
        setmodalCancelamentoTS(false);
        window.location.reload();
    }

    const closeModalItemAtividadeHistoricoTimesheetIsOpen = () => {
        setModalItemAtividadeHistoricoTimesheetIsOpen(false);

    }

    const closeModalTimeSheetHistoricoIsOpen = () => {
        setModalTimeSheetHistoricoIsOpen(false);

    }

    const closeModalTimesheetFinalizar = () => {
        setModalTimeshetFinalizarIsOpen(false);
    }

    const closeModalTimesheetReverterTS = () => {
        setModalTimeshetReverterTSIsOpen(false);
        window.location.reload();
    };

    const closeNotifyModal = () => {
        setNotifyIsOpen(false);
    }

    const closeNotifyGrupoModal = () => {
        setNotifyGrupoIsOpen(false);
    }

    const closeNotifyHistoricoModal = () => {
        setModalNotifyHistoricoIsOpen(false);
    }

    const closeNotifyGrupoHistoricoModal = () => {
        setModalNotifyGrupoHistoricoIsOpen(false);
    }

    const closeEditModal = () => {
        setEditIsOpen(false);
    }

    const closeCancelModal = () => {
        setCancelIsOpen(false);
    }

    const closeTimerModal = () => {
        setTimerIsOpen(false);
    }

    const closeBillingModal = () => {
        setBillingIsOpen(false);
    }

    const closeMeritocracyModal = () => {
        setMeritocracyIsOpen(false);
    }

    const closeReviewModal = () => {
        setReviewIsOpen(false);
    }

    const openTableFormListModal = () => {
        setmodalTableFormAtividadeListIsOpen(true);
    }

    const openNovoGrupoAtividadeModal = (grupoAtividade) => {
        setselectedGrupoAtividade(grupoAtividade);
        setmodalNovoGrupoAtividadeIsOpen(true);
    }
    const closeNovoGrupoAtividadeModal = (event) => {
        if (event?.type === 'keydown' && event?.keyCode === 27) return
        setmodalNovoGrupoAtividadeIsOpen(false);
    }

    const openGrupoAtividadeCancelModal = (grupoAtividade) => {
        setselectedGrupoAtividade(grupoAtividade);
        setmodalGrupoAtividadeCancelIsOpen(true);
    }
    const closeGrupoAtividadeCancelModal = () => {
        setmodalGrupoAtividadeCancelIsOpen(false);
    }

    const modalNovoGrupoAtividadeOpen = () => { }

    const closeTableFormListModal = (event) => {
        if (event.type === 'keydown' && event.keyCode === 27) return
        setmodalTableFormAtividadeListIsOpen(false);
    }

    const getAtividadeTimeSheetCanceledo = (status) => {
        showCanceledTimeSheet = status;
        setCanceledTimeSheet(showCanceledTimeSheet);
        getTimesheetAtividade(status);
    };

    const getGrupoAtividadeTimeSheetCanceledo = (status) => {
        getTimesheetGrupoAtividade(status);
    };

    const openModalAprovar = () => {
        setModalAprovarIsOpen(true);
    };

    const closeModalAprovar = () => {
        setModalAprovarIsOpen(false);
    }

    const openModalReprovar = () => {
        setModalReprovarIsOpen(true);
    };

    const closeModalReprovar = () => {
        setModalReprovarIsOpen(false);
    }

    const openModalConcluir = () => {
        setModalConcluirIsOpen(true);
    };

    const closeModalConcluir = () => {
        setModalConcluirIsOpen(false);
    }

    const openModalCancelar = (item) => {
        setPendenciaDeAprovacao(item)
        setModalCancelarIsOpen(true);
    };

    const closeModalCancelar = () => {
        setModalCancelarIsOpen(false);
    }

    const openModalMesclarTimseheet = (item) => {
        setModalMesclarTimesheetIsOpen(true);
    };

    const closeModalMesclarTimseheet = () => {
        setModalMesclarTimesheetIsOpen(false);
    }

    const openModalEsclarecimento = (item) => {
        setModalEsclarecimentoIsOpen(true);
    };

    const closeModalEsclarecimento = () => {
        setModalEsclarecimentoIsOpen(false);
    }

    const getTimesheetAtividade = async (status = false) => {
        valoresAtividades.splice(0, valoresAtividades.length);
        const timesheetAtividade = await getTimesheetAtividadeById(location.hash.replace("#", ''), status);
        // getAtividadesList(timesheetAtividade);
        if (!!timesheetAtividade) {
            {
                timesheetAtividade.itens.map((item, index) => {
                    valoresAtividades.push({
                        "idTimesheetItemAtividade": item.idTimesheetItemAtividade,
                        "data": item.datalancamento,
                        "perito": item.peritoNome,
                        "atividades": item.atividade,
                        "observacoes": item.descricao,
                        "inicio": item.periodoInicio,
                        "termino": item.periodoFim,
                        "intervalo": item.intervaloHoras,
                        "horas": item.baseHoras,
                        "valorhora": <span className="table-value">{item.valorHoraBase}</span>,
                        "total": <span className="table-nowrap">{item.totalValorFaturado}</span>,
                        "status": item.status,
                        "actions": item.actions,
                        "nameClass": item.nameClass,
                        "acoes": <div style={{ width: "130px" }}>
                            {item.actions.detalhes ? <i className="fa fa-file-text-o table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openModalItemAtividadeTimesheetHistoricoIsOpen(item)} title="Histórico"></i> : <i className="fa fa-file-text-o" aria-hidden="true" title="Histórico"></i>} &nbsp;
                            {item.actions.editar ? <i className="fa fa-pencil table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openEditModal(item)} title="Editar"></i> : <i className="fa fa-pencil" aria-hidden="true" title="Editar"></i>} &nbsp;
                            {item.actions.cancelar ? <i className="fa fa-times table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openCancelModal(item.idTimesheetItemAtividade)} title="Cancelar"></i> : <i className="fa fa-times" aria-hidden="true" title="Cancelar"></i>} &nbsp;
                            {item.actions.notificar ? <i className="fa fa-bell table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openNotifyModal(item.idTimesheetItemAtividade)} title="Notificar"></i> : <i className="fa fa-bell" aria-hidden="true" title="Notificar"></i>} &nbsp;
                            {/* { item.actions.ajustarTimer ? <i className="fa fa-clock-o table-color-button" aria-hidden="true" onClick={openTimerModal}></i> : <i className="fa fa-clock-o" aria-hidden="true"></i> } &nbsp;
                                { item.actions.faturamento ? <i className="fa fa-usd table-color-button" aria-hidden="true" onClick={openBillingModal}></i> : <i className="fa fa-usd" aria-hidden="true"></i> } &nbsp;
                                { item.actions.meritocracia  ? <i className="fa fa-trophy table-color-button" aria-hidden="true" onClick={openMeritocracyModal}></i> : <i className="fa fa-trophy" aria-hidden="true"></i> } &nbsp;
                                { item.actions.revisar  ? <i className="fa fa-search table-color-button" aria-hidden="true" onClick={openReviewModal}></i> : <i className="fa fa-search" aria-hidden="true"></i> } &nbsp; */}
                        </div>
                    })
                })
            }
            setTimesheetAtividade(timesheetAtividade);
            setValoresAtividades(valoresAtividades);


            if (isDesktop) {  //se desktop exibe em tabela
                setTimeout(() => {
                    setDefaultVisaoAtividades(true);
                    isDataAtividade = true;
                    setIsDataAtividade(isDataAtividade);
                }, 1000);

            } else {
                isDataAtividade = true;
                setIsDataAtividade(isDataAtividade);
            }

        }
    };

    const getTimesheetGrupoAtividade = async (status = false) => {
        const timesheetGrupoAtividade = await getTimesheetGrupoAtividadeById(location.hash.replace("#", ''), status);
        if (!!timesheetGrupoAtividade) {
            setTimesheetGrupoAtividade(timesheetGrupoAtividade);

            if (isDesktop) { //se desktop exibe em tabela
                setTimeout(() => {
                    setDefaultVisaoGrupo(true);
                }, 1000);
            }
        }
    }

    const getResumoFinalizar = async () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': false
            }
        }
        try {
            const response = await api.get(`timesheet/${location.hash.replace("#", '')}/finalizar`, config);

            const idTimesheet = location.hash.replace("#", '');
            const tsAtividade = await getTimesheetAtividadeById(idTimesheet, false);

            let qtdVistorias = 0;
            let qtdReunioes = 0;
            let qtdTotalVR = 0;
            if (tsAtividade.itens && Array.isArray(tsAtividade.itens)) {
                qtdVistorias = tsAtividade.itens.filter(item => item.atividade === "Vistoria").length;
                qtdReunioes = tsAtividade.itens.filter(item => item.atividade === "Reunião externa").length;
            }
            qtdTotalVR = qtdVistorias + qtdReunioes;
            const resumoComVistorias = {
                ...response.data.data,
                qtdTotalVR
            };

            setFinalizarResumo(resumoComVistorias);
            setFinalizarResumoAccess(response.data.access);
        } catch (err) { }
    }

    const getPrecificacao = async () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': false
            }
        }
        try {
            const response = await api.get(`TimesheetPrecificacao/${location.hash.replace("#", '')}`, config);
            setTimesheetPrecificacao(response.data.data);
        } catch (err) { }
    }

    const getDescontoComercial = async () => {
        try {
            const response = await api.get(`TimesheetDescontoComercial/${location.hash.replace("#", '')}`, config);
            setTimesheetDescontoComercial(response?.data?.data);
        } catch (err) { }
    }

    colunas = useMemo(
        () => [
            {
                Header: "I",
                hideHeader: false,
                columns: [
                    {
                        Header: "Data",
                        accessor: "data",
                        sortType: (a, b) => {
                            const parseDMY = s => {
                                let [d, m, y] = s.split(/\D/);
                                return new Date(y, m - 1, d);
                            };
                            return new Date(parseDMY(a.values.data)) - new Date(parseDMY(b.values.data));
                        }
                    },
                    {
                        Header: "Profissional",
                        accessor: "perito",
                        class: "fixed-width-200 "
                    },
                    {
                        Header: "Atividades",
                        accessor: "atividades",
                        class: "fixed-width-390"
                    },
                    {
                        Header: "Descrição",
                        accessor: "observacoes",
                        class: "fixed-width-180"
                    },
                    {
                        Header: "Início",
                        accessor: "inicio",
                        sortType: (a, b) => {
                            const horaA = a.values.inicio.split(":");
                            const horaB = b.values.inicio.split(":");

                            // Convertendo as horas para números inteiros
                            const horaIntA = parseInt(horaA[0], 10);
                            const minutoIntA = parseInt(horaA[1], 10);
                            const horaIntB = parseInt(horaB[0], 10);
                            const minutoIntB = parseInt(horaB[1], 10);

                            // Comparando as horas
                            if (horaIntA === horaIntB) {
                                // Se as horas são iguais, compare os minutos
                                return minutoIntA - minutoIntB;
                            } else {
                                return horaIntA - horaIntB;
                            }
                        }
                    },
                    {
                        Header: "Término",
                        accessor: "termino"
                    },
                    {
                        Header: "Intervalo",
                        accessor: "intervalo"
                    },
                    {
                        Header: "Horas",
                        accessor: "horas"
                    },
                    {
                        Header: "Valor/Hora",
                        accessor: "valorhora"
                    },
                    {
                        Header: "Total",
                        accessor: "total"
                    },
                    {
                        Header: "Status",
                        accessor: "status"
                    },
                    {
                        Header: "Ações",
                        accessor: "acoes",
                        width: 90,
                        class: "fixed-width-90"
                    }
                ]
            }
        ],
        []
    );

    const dataAtividadeList = [];
    colunasAtividadeList = useMemo(
        () => [
            {
                Header: "I",
                hideHeader: false,
                columns: [
                    {
                        Header: "Data",
                        accessor: "data"
                    },
                    {
                        Header: "Atividade",
                        accessor: "atividade"
                    },
                    {
                        Header: "Descrição",
                        accessor: "descricao"
                    },
                    {
                        Header: "Hora inicial",
                        accessor: "horainicial"
                    },
                    {
                        Header: "Hora final",
                        accessor: "horafinal"
                    },
                    {
                        Header: "Intervalo",
                        accessor: "almoco"
                    },
                    {
                        Header: "Valor da hora",
                        accessor: "valorhora"
                    },
                    {
                        Header: "Valor base",
                        accessor: "base"
                    },
                    {
                        Header: "Total",
                        accessor: "Total"
                    },
                    {
                        Header: "Incluir",
                        accessor: "incluir",
                        width: 90
                    }
                ]
            }
        ],
        []
    );



    colunasGrupo = useMemo(
        () => [
            {
                Header: "I",
                hideHeader: false,
                columns: [
                    {
                        Header: "Data",
                        accessor: "data",
                        sortType: (a, b) => {
                            const parseDMY = s => {
                                let [d, m, y] = s.split(/\D/);
                                return new Date(y, m - 1, d);
                            };
                            return new Date(parseDMY(a.values.data)) - new Date(parseDMY(b.values.data));
                        }
                    },
                    {
                        Header: "Profissional",
                        accessor: "perito",
                        class: "fixed-width-200 "
                    },
                    {
                        Header: "Atividades",
                        accessor: "atividades",
                        class: "fixed-width-390"
                    },
                    {
                        Header: "Descrição",
                        accessor: "observacoes",
                        class: "fixed-width-180"
                    },
                    {
                        Header: "Início",
                        accessor: "inicio",
                    },
                    {
                        Header: "Término",
                        accessor: "termino"
                    },
                    {
                        Header: "Quantidade",
                        accessor: "quantidade"
                    },
                    {
                        Header: "Valor/Hora",
                        accessor: "valorhora"
                    },
                    {
                        Header: "Horas",
                        accessor: "horas"
                    },

                    {
                        Header: "Total",
                        accessor: "total"
                    },
                    {
                        Header: "Status",
                        accessor: "status"
                    },
                    {
                        Header: "Ações",
                        accessor: "acoes",
                        width: 90,
                        class: "fixed-width-90"
                    }
                ]
            }
        ],
        []
    );

    const loadPage = async () => {
        const timesheet = await getTimesheetById(location.hash.replace("#", ''));

        if (!!timesheet) {
            setPendenciaDeAprovacao(timesheet.pendenciaAprovacao)
            setTimesheet(timesheet);
        }

        const resumo = await getTimesheeResumotById(location.hash.replace("#", ''));

        if (!!resumo) {
            setResumo(resumo);
        }

        const atividades = await getAtividades(40);
        if (!!atividades) {
            setAtividades(atividades)
        }

        const resumoDasAtividades = await getTimesheetAtividadeGroup(location.hash.replace("#", ''), false)
        setResumoAtividades(resumoDasAtividades);

        const resumoDasAtividadesModal = await getTimesheetAtividadeGroupResumo(location.hash.replace("#", ''), false)
        setResumoAtividadesModal(resumoDasAtividadesModal);

        const peritos = await getPeritos();
        if (!!peritos) {
            setPeritosList(peritos);
            let peritosFormatados = [];
            peritos.map(perito => {
                peritosFormatados.push({
                    "value": perito.idUsuario,
                    "id": perito.idUsuario,
                    "label": `${perito.nome}`
                });
            });
            setPeritosListFormatado(peritosFormatados)
        }

        await getTimesheetAtividade(showCanceledTimeSheet);

        await getTimesheetGrupoAtividade();

        await getResumoFinalizar();

        await getPrecificacao();

        await getDescontoComercial();
    }

    useEffect(() => {
        const asyncFn = async () => {
            loadPage()
        };

        asyncFn()
    }, [valoresAtividades]);

    const redirecionAposSucesso = async () => {
        loadPage()
    }


    const exportOptions = async () => {


        if (timesheet.actions.export) {


            if (timesheet.actions.exportToCliente) {
                await exportToPDF(false);
            } else if (timesheet.actions.exportRascunhoTS) {
                await exportToPDF(true);
            }

        }

    }


    const checkisCRT = () => {
        const patern = /(\d{4})([R])/gi;
        return patern.test(timesheet?.pericia?.sigla);
    };

    const exportToPDF = async (isRascunho = false) => {
        var doc = new jsPDF('landscape')
        var totalPagesExp = '{total_pages_count_string}'

        var headerMarginTop = timesheet?.descontoComercial == null ? 50 : 63;


        const isCheckisCRT = checkisCRT();
        const logo_final = isCheckisCRT ? logo_mc : logo;

        doc.autoTable({
            html: '#my-table',
            useCss: true,
            rowPageBreak: 'avoid',
            margin: { top: headerMarginTop, bottom: 20 },
            columnStyles: {
                2: { cellWidth: 115 },
                6: { cellWidth: 'wrap' },
                8: { cellWidth: 'wrap' }
            },
            willDrawPage: function (data) {

                doc.addImage(logo_final, 'PNG', data.settings.margin.left, 10, 30, 8);

                var pageSize = doc.internal.pageSize
                var pageWidth = pageSize.windth ? pageSize.windth : pageSize.getWidth();

                doc.autoTable({
                    html: '#my-table-header',
                    useCss: true,
                    margin: { top: 23 },
                })

                doc.setFontSize(15)
                doc.setTextColor(44, 59, 130);
                if (isCheckisCRT) {
                    doc.setTextColor(0, 112, 182);
                }


                doc.setFont(undefined, 'bold');
                doc.text('Planilha de Honorários', pageWidth / 2, 15, { align: 'center' })
            },
            didDrawPage: function (data) {
                // Footer
                var str = 'Página ' + doc.internal.getNumberOfPages()
                if (typeof doc.putTotalPages === 'function') {
                    str = str + ' de ' + totalPagesExp
                }

                doc.setFontSize(10);
                doc.setTextColor(44, 59, 130);
                if (isCheckisCRT) {
                    doc.setTextColor(0, 112, 182);
                }
                var pageSize = doc.internal.pageSize
                var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                var pageWidth = pageSize.windth ? pageSize.windth : pageSize.getWidth()
                doc.text(str, pageWidth - 40, pageHeight - 10)

                isCheckisCRT ?
                    doc.text('Avenida Angélica, 2163 10º andar, Conjuntos 101 e 102, Higienópolis - São Paulo–SP, Cep:01227-200 \n (011) 3138-5598 | www.crtadjusters.com.br | contato@crtadjusters.com.br', 
                        pageWidth / 2, pageHeight - 13, { align: 'center' })   
                :                    
                    doc.text(
                        'Avenida Angélica, 2133 7º andar, Higienópolis - São Paulo–SP, Cep:01227-200 \n (011) 3256-2702 | www.criterioexperts.com.br | contato@criterioexperts.com.br',
                        pageWidth / 2, pageHeight - 13, { align: 'center' })
            },

        })

        if (timesheetGrupoAtividade.itens.length > 0) {
            // doc.addPage();

            doc.autoTable({
                html: '#my-table-grupo',
                useCss: true,
                margin: { top: 50, bottom: 20 },
                rowPageBreak: 'avoid',
                willDrawPage: function (data) {

                    doc.addImage(logo_final, 'PNG', data.settings.margin.left, 10, 30, 8);

                    var pageSize = doc.internal.pageSize
                    var pageWidth = pageSize.windth ? pageSize.windth : pageSize.getWidth();

                    doc.autoTable({
                        html: '#my-table-header',
                        useCss: true,
                        margin: { top: 23 },
                        startY: 23,
                    })

                    doc.setFontSize(15)
                    doc.setTextColor(44, 59, 130);
                    if (isCheckisCRT) {
                        doc.setTextColor(0, 112, 182);
                    }
                    doc.setFont(undefined, 'bold');
                    doc.text('Planilha de Honorários', pageWidth / 2, 15, { align: 'center' })
                },
                didDrawPage: function (data) {
                    // Footer
                    var str = 'Página ' + doc.internal.getNumberOfPages()
                    if (typeof doc.putTotalPages === 'function')
                        str = str + ' de ' + totalPagesExp
                    doc.setFontSize(10);
                    doc.setTextColor(44, 59, 130);
                    if (isCheckisCRT) {
                        doc.setTextColor(0, 112, 182);
                    }
                    var pageSize = doc.internal.pageSize
                    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                    var pageWidth = pageSize.windth ? pageSize.windth : pageSize.getWidth()
                    doc.text(str, pageWidth - 40, pageHeight - 10)

                    isCheckisCRT ?
                    doc.text('Avenida Angélica, 2163 10º andar, Conjuntos 101 e 102, Higienópolis - São Paulo–SP, Cep:01227-200 \n (011) 3138-5598 | www.crtadjusters.com.br | contato@crtadjusters.com.br', 
                        pageWidth / 2, pageHeight - 13, { align: 'center' })   
                :                    
                    doc.text(
                        'Avenida Angélica, 2133 7º andar, Higienópolis - São Paulo–SP, Cep:01227-200 \n (011) 3256-2702 | www.criterioexperts.com.br | contato@criterioexperts.com.br',
                        pageWidth / 2, pageHeight - 13, { align: 'center' })
                },
            })
        }


        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }

        var nomeArquivo = `TS_CES_${timesheet?.pericia?.sigla}_${timesheet?.timesheet?.numeroTimesheet}.pdf`;

        if (!isRascunho) {
            doc.save(nomeArquivo);
            return;
        }


        doc = addWaterMark(doc);
        openModalRascunhoTS(doc.output('datauristring'), nomeArquivo);


    }


    const addWaterMark = (doc) => {
        const totalPages = doc.internal.getNumberOfPages();

        const marcaDaguaTexto = 'Rascunho';
        const tamanhoFonte = 40; // Tamanho da fonte da marca d'água
        const corTexto = '#CCCCCC'; // Cor do texto da marca d'águuaD
        //const corTexto = '#e6e6e6'; // Cor do texto da marca d'águuaD
        const margem = 10; // Margem da página
        const rotacao = 45; // Ângulo de rotação da marca d'água

        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);

            const larguraPagina = doc.internal.pageSize.getWidth();
            const alturaPagina = doc.internal.pageSize.getHeight();


            doc.setFontSize(tamanhoFonte);
            const larguraTexto = doc.getStringUnitWidth(marcaDaguaTexto) * tamanhoFonte / doc.internal.scaleFactor;
            const alturaTexto = tamanhoFonte / doc.internal.scaleFactor;

            // Calcular posição inicial da marca d'água
            let x = margem;
            let y = margem;



            while (y < alturaPagina + alturaTexto) {
                while (x < larguraPagina + larguraTexto) {


                    doc.saveGraphicsState();
                    doc.setGState(new doc.GState({ opacity: 0.4 }));
                    doc.setTextColor(corTexto);
                    doc.setFontSize(tamanhoFonte);
                    doc.text(marcaDaguaTexto, x, y, { angle: rotacao });

                    doc.restoreGraphicsState();

                    x += larguraTexto * 1; // Espaçamento horizontal entre as marcas d'água
                }
                x = margem;
                y += alturaTexto * 3; // Espaçamento vertical entre as marcas d'água
            }

        }

        return doc;
    }


    const openModalRascunhoTS = (stringDoc, nomeArquivo) => {

        const downloadModal = `<a id="linkExportacao" style="padding: 0.5rem 1rem; text-decoration: none; cursor: pointer; font-weight: 600; border: solid 1px #EE4B21; border-radius: 0.25rem; background-color: #EE4B21; color: #FFF; font-size: 0.8rem; &:hover {background-color: #c83e1b; border: solid 1px #c83e1b; } &:disabled {cursor: not-allowed; }"
                                    href='${stringDoc}' download='${nomeArquivo}'>
                                               <span style="color: #fff">
                                                   ${nomeArquivo}
                                                   <span style="width:20px"><svg  width="20"  fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"/></svg></span>
                                                   </span>
                                           </a>`;

        const text = `<div style='height: 630px;margin-top: 20px;overflow-y: hidden;'>
                                           <iframe width='100%' height='100%' src='${stringDoc}#toolbar=0'></iframe>
                                           <div>
                                           ${downloadModal}
                                           </div>
                                           </div>`;

        Swal.fire({
            footer: downloadModal,
            html: text,
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: false,
            focusConfirm: false,
            cancelButtonText: `Fechar`,
            customClass: 'swal-wide',
            width: '85%',
            showClass: {
                popup: `animate__fadeInUp`
            },
            hideClass: {
                popup: `animate__fadeOutDown`
            }
        });
    }

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <ExportacaoTimsheetTemplate
                        timesheet={timesheet}
                        timesheetAtividade={timesheetAtividade}
                        timesheetGrupoAtividade={timesheetGrupoAtividade}
                    ></ExportacaoTimsheetTemplate>
                    <div className="card">
                        <div className="timesheet">
                            <PartialTsDetalhado/>
                            <div className="row ">
                                <div className="col-sm-12 col-md-6 timesheet-detalhes">
                                    <PartialSeguradora/>
                                    <PartialSegurado />
                                </div>
                                <div className="col-sm-12 col-md-6 timesheet-detalhes">
                                    <PartialCriterio />
                                </div>
                            </div>
                            {
                                timesheet?.pendenciaAprovacao && (
                                    <PendenciaDeAprovacao
                                        pendenciaAprovacao={timesheet?.pendenciaAprovacao}
                                        timesheet={timesheet}
                                        openModalConcluir={openModalConcluir}
                                        openModalAprovar={openModalAprovar}
                                        openModalReprovar={openModalReprovar}
                                    />
                                )
                            }
                            <AcoesTimesheetDetalhes
                                openModal={openModalTimesheetIsOpen}
                                openFinalizarModal={openModalTimesheetFinalizarIsOpen}
                                openModalReverterTSOpen={openModalReverterTSOpen}
                                openTimeSheetHistoricoModal={openModalTimeSheetHistoricoIsOpen}
                                finalizarResumoAccess={finalizarResumoAccess}
                                exportOptions={exportOptions}
                                openModalConfigurarPrecoOpen={openModalConfigurarPrecoOpen}
                                openModalConfigurarDescontoOpen={openModalConfigurarDescontoOpen}
                                openModalObservacoesOpen={openModalObservacoesOpen}
                                openModalMesclarTimseheet={openModalMesclarTimseheet}
                                possuiPrecificacaoConfigurado={timesheetPrecificacao != null}
                                openModalEsclarecimento={openModalEsclarecimento}
                                openModalCancelamentoTSOpen={openModalCancelamentoTSOpen}
                                openModalProbono={openModalProbono}
                            />
                        </div>
                    </div>
                    <div className="card">
                        <div className="timesheet">
                            <Flex className="row">
                                <Flex.Item className="col-md-2 col-lg-2">
                                    <span className="grid-legend-info-1">Atividades</span>
                                </Flex.Item>
                                <Flex.Item className="col-sm-12  col-lg-3 ">
                                    <div className="row">
                                        <Flex.Item className="col-sm-6 col-md-6 pt-2">
                                            <div className="form-wrapper filter-container">
                                                <div className="form-container flex-column justify-content-center legend-info">
                                                    <ToggleSwitch config={advanceTimesheet} setStatus={(status) => getAtividadeTimeSheetCanceledo(status)} inicialStatus={false} />
                                                </div>
                                            </div>
                                        </Flex.Item>
                                        <Flex.Item className="col-sm-6 col-md-6 pt-2 pb-2" >
                                            <div className="form-wrapper filter-container">
                                                <div className="form-container flex-column justify-content-center legend-info">
                                                    <ToggleSwitch config={advanceTimesheetVisualizacaoTp} setStatus={(status) => mudarVisaoAtividades(status)} inicialStatus={showAtividades} />
                                                </div>
                                            </div>
                                        </Flex.Item>
                                    </div>
                                </Flex.Item>
                                <Flex.Item className="col-xs-12 col-sm-12  col-lg-7 ">
                                    <div className="row justify-content-end justify-content-xl-center">
                                        { timesheet?.actions?.importarTS && (
                                            <Flex.Item className="col-sm-6 col-md-4 px-0 pull-right"> <UploadTimeSheet idTimesheet={location.hash.replace("#", '')} isOpen={uploadIsOpen} timesheet={timesheet} disabledUpload={!finalizarResumoAccess?.isEdit} /></Flex.Item>
                                        )}
                                        {isDesktop && timesheetPrecificacao != null && finalizarResumoAccess?.isEdit && (
                                            <Flex.Item className="col-sm-6 col-md-4 px-1"> <input className='default-button-red btn-block' value='Nova Atividade em Lote' type="button" onClick={openTableFormListModal} disabled={!finalizarResumoAccess?.isEdit} /></Flex.Item>
                                        )}
                                        {
                                            finalizarResumoAccess?.isEdit && timesheetPrecificacao != null && (
                                                <Flex.Item className="col-xs-12 col-sm-12 col-md-3 px-0">  <input className='default-button-red btn-block btn-remove-max-width' value='Nova Atividade' type="button" onClick={openModal} /></Flex.Item>
                                            )
                                        }
                                    </div>
                                </Flex.Item>
                            </Flex>
                            <br />
                            <TableFormAtividadeList atividades={atividades} peritos={peritosList} columns={colunasAtividadeList} data={dataAtividadeList} isOpen={modalTableFormAtividadeListIsOpen} onRequestClose={closeTableFormListModal} />
                            <br />
                            {(() => {
                                if (isDataAtividade) {
                                    if (showAtividades && !!timesheetAtividade && timesheetAtividade?.itens?.length > 0) {
                                        return (
                                            <div className="table-scroll">
                                                <Table columns={colunas} data={valoresAtividades} timesheetAtividades={timesheetAtividade}
                                                    openModalItemAtividadeTimesheetHistoricoIsOpen={openModalItemAtividadeTimesheetHistoricoIsOpen}
                                                    openEditModal={openEditModal}
                                                    openCancelModal={openCancelModal}
                                                    openNotifyModal={openNotifyModal}
                                                    openNotifyHistoricoModal={openNotifyHistoricoModal}
                                                    canEdit={finalizarResumoAccess?.isEdit}
                                                />
                                            </div>
                                        )
                                    }
                                    else {
                                        return (
                                            <StldRow>
                                                {timesheetAtividade.itens.map((item, index) => {
                                                    if (item.idTimesheet !== "")
                                                        return (
                                                            <StldColumn key={index} xs="12" sm="6" md="3">
                                                                <CardTableAtividadesOptions
                                                                    item={item}
                                                                    getCardId={getCardId}
                                                                    openCancelModal={openCancelModal}
                                                                    openModalItemAtividadeTimesheetHistoricoIsOpen={openModalItemAtividadeTimesheetHistoricoIsOpen}
                                                                    openEditModal={openEditModal}
                                                                    openNotifyModal={openNotifyModal}
                                                                    openNotifyHistoricoModal={openNotifyHistoricoModal}
                                                                    canEdit={finalizarResumoAccess?.isEdit}
                                                                />
                                                            </StldColumn>
                                                        )
                                                })}
                                            </StldRow>
                                        )
                                    }
                                }


                            })()}
                        </div>
                    </div>
                    <div className="card">
                        <div className="timesheet">
                            <Flex className="row">
                                <Flex.Item style={{ minWidth: "100px" }} className="col-md-2">
                                    <span className="grid-legend-info-1">Grupo de Atividades</span>
                                </Flex.Item>
                                <Flex.Item className="col-sm-12 col-md-6 col-lg-4 row">
                                    <Flex.Item className="col-sm-6 col-md-6 pt-2">
                                        <div className="form-wrapper filter-container">
                                            <div className="form-container flex-column justify-content-center legend-info">
                                                <ToggleSwitch config={advanceTimesheetGrupo} setStatus={(status) => getGrupoAtividadeTimeSheetCanceledo(status)} inicialStatus={false} />
                                            </div>
                                        </div>
                                    </Flex.Item>
                                    <Flex.Item className="col-sm-6 col-md-6 pt-2 pb-2" >
                                        <div className="form-wrapper filter-container">
                                            <div className="form-container flex-column justify-content-center legend-info">
                                                <ToggleSwitch config={advanceTimesheetVisualizacaoTpGrupo} setStatus={(status) => mudarVisaoGrupo(status)} inicialStatus={!showGroup} />
                                            </div>
                                        </div>
                                    </Flex.Item>
                                </Flex.Item>

                                <Flex.Item className="col-sm-12 col-md-6">
                                    <div className="flex-column-right">
                                        {
                                            finalizarResumoAccess?.isEdit && timesheetPrecificacao != null && (
                                                <input className='default-button-red' value='Novo Grupo de Atividades' type="button" onClick={() => openNovoGrupoAtividadeModal()} />
                                            )
                                        }
                                    </div>
                                </Flex.Item>
                            </Flex>
                            {(() => {
                                if (showGroup && !!timesheetGrupoAtividade && timesheetGrupoAtividade?.itens?.length > 0) {
                                    return (
                                        <div className="table-scroll">
                                            <TableGroup
                                                columns={colunasGrupo}
                                                data={timesheetGrupoAtividade}
                                                openNovoGrupoAtividadeModal={openNovoGrupoAtividadeModal}
                                                openNotifyGrupoModal={openNotifyGrupoModal}
                                                openGrupoAtividadeCancelModal={openGrupoAtividadeCancelModal}
                                                openNotifyGrupoHistoricoModal={openNotifyGrupoHistoricoModal}
                                                canEdit={finalizarResumoAccess?.isEdit} />
                                        </div>
                                    )
                                }
                                else {
                                    return (
                                        <StldRow>
                                            {timesheetGrupoAtividade.itens.map((item, index) => {
                                                return (
                                                    <StldColumn key={index} xs="12" sm="6" md="4">
                                                        <CardTableGrupoOptions
                                                            item={item}
                                                            openNovoGrupoAtividadeModal={openNovoGrupoAtividadeModal}
                                                            openNotifyGrupoModal={openNotifyGrupoModal}
                                                            openGrupoAtividadeCancelModal={openGrupoAtividadeCancelModal}
                                                            openNotifyGrupoHistoricoModal={openNotifyGrupoHistoricoModal}
                                                            index={index}
                                                            canEdit={finalizarResumoAccess?.isEdit}
                                                        />
                                                    </StldColumn>
                                                )
                                            })}
                                        </StldRow>
                                    )
                                }
                            })()}
                        </div>
                    </div>

                    <ModalTimeSheetDetalhes
                        atividades={atividades}
                        location={location}
                        peritosList={peritosList}
                        isOpen={modalIsOpen}
                        setIsOpen={setIsOpen}
                        showCanceledTimeSheet={showCanceledTimeSheet}
                        loadPage={loadPage}
                    >
                    </ModalTimeSheetDetalhes>
                    <ModalDetails
                        atividades={atividades}
                        isOpen={modalDetailsIsOpen}
                        onAfterOpen={afterDetailsOpenModal}
                        onRequestClose={closeDetailsModal}
                        ariaHideApp={false}>
                    </ModalDetails>
                    <ModalTimesheetResumo
                        isOpen={modalTimesheetIsOpen}
                        onRequestClose={closeModalTimesheet}
                        ariaHideApp={false}
                        resumo={resumo}
                        resumoAtividades={resumoAtividadesModal}
                    >
                    </ModalTimesheetResumo>
                    <ModalTimesheetProBonoResumo
                        isOpen={modalTimesheeProbonoResumotIsOpen}
                        onRequestClose={closeModalProbono}
                        ariaHideApp={false}
                        resumo={resumo}
                        resumoAtividades={resumoAtividades}
                    >
                    </ModalTimesheetProBonoResumo>
                    <ModalTimesheetItemAtividadeHistorico
                        isOpen={modalItemAtividadeHistoricoTimesheetIsOpen}
                        onRequestClose={closeModalItemAtividadeHistoricoTimesheetIsOpen}
                        ariaHideApp={false}
                        atividade={selectedAtividade}

                    >
                    </ModalTimesheetItemAtividadeHistorico>

                    <ModalTimeSheetHistorico
                        isOpen={modalTimeSheetHistoricoIsOpen}
                        onRequestClose={closeModalTimeSheetHistoricoIsOpen}
                        ariaHideApp={false}
                        idTimesheet={location.hash.replace("#", '')}
                    >
                    </ModalTimeSheetHistorico>

                    <ModalTimesheetFinalizar
                        isOpen={modalTimeshetFinalizarIsOpen}
                        onRequestClose={closeModalTimesheetFinalizar}
                        ariaHideApp={false}
                        timesheet={timesheet}
                        finalizarResumo={finalizarResumo}
                        finalizarResumoAccess={finalizarResumoAccess}
                    ></ModalTimesheetFinalizar>
                    <ModalReverterTS
                        loadPage={loadPage}
                        isOpen={modalTimeshetReverterTSIsOpen}
                        onRequestClose={closeModalTimesheetReverterTS}
                        idTimesheet={timesheet?.timesheet?.idTimesheet}
                    ></ModalReverterTS>
                    <ModalNotifyGrupo
                        isOpen={modalNotifyGrupoIsOpen}
                        onAfterOpen={afterNotifyGrupoOpenModal}
                        onRequestClose={closeNotifyGrupoModal}
                        loadPage={loadPage}
                        selectedGrupoAtividade={selectedGrupoAtividade}
                    >
                    </ModalNotifyGrupo>

                    <ModalConfigurarPreco
                        timesheetPrecificacao={timesheetPrecificacao}
                        isOpen={modalConfigurarPreco}
                        onAfterOpen={afterNotifyGrupoOpenModal}
                        onRequestClose={closeModalConfigurarPreco}
                        loadPage={loadPage}
                        peritos={peritosListFormatado}
                    >
                    </ModalConfigurarPreco>

                    <ModalConfigurarDesconto
                        timesheetDescontoComercial={timesheetDescontoComercial}
                        isOpen={modalConfigurarDesconto}
                        onAfterOpen={afterNotifyGrupoOpenModal}
                        onRequestClose={closeModalConfigurarDesconto}
                        loadPage={loadPage}
                        peritos={peritosListFormatado}
                    >
                    </ModalConfigurarDesconto>

                    <ModalObservacao
                        isOpen={modalObservacoes}
                        onAfterOpen={afterNotifyGrupoOpenModal}
                        onRequestClose={closeModalObservacoes}
                        idTimesheet={timesheet?.timesheet?.idTimesheet}
                    >
                    </ModalObservacao>

                    <ModalCancelamentoTS
                        isOpen={modalCancelamentoTS}
                        onAfterOpen={afterNotifyGrupoOpenModal}
                        onRequestClose={closeModalCancelamentoTS}
                        idTimesheet={timesheet?.timesheet?.idTimesheet}
                        loadPage={loadPage}
                    >
                    </ModalCancelamentoTS>

                    <ModalNotifyGrupoHistorico
                        isOpen={modalNotifyGrupoHistoricoIsOpen}
                        onRequestClose={closeNotifyGrupoHistoricoModal}
                        ariaHideApp={false}
                        atividade={selectedGrupoAtividade}
                    >
                    </ModalNotifyGrupoHistorico>

                    <ModalNotify
                        isOpen={modalNotifyIsOpen}
                        onAfterOpen={afterNotifyOpenModal}
                        onRequestClose={closeNotifyModal}
                        loadPage={loadPage}
                    >
                    </ModalNotify>

                    <ModalNotifyHistorico
                        isOpen={modalNotifyHistoricoIsOpen}
                        onRequestClose={closeNotifyHistoricoModal}
                        ariaHideApp={false}
                        atividade={selectedAtividade}
                    >
                    </ModalNotifyHistorico>

                    <ModalEdit
                        atividades={atividades}
                        timesheetItemAtividade={timesheetItemAtividade}
                        isOpen={modalEditIsOpen}
                        setIsOpen={closeEditModal}
                        onAfterOpen={afterEditOpenModal}
                        onRequestClose={closeEditModal}
                        peritosList={peritosList}
                        timesheet={timesheet}
                        loadPage={loadPage}
                    >
                    </ModalEdit>
                    <ModalCancel
                        isOpen={modalCancelIsOpen}
                        onAfterOpen={afterCancelOpenModal}
                        onRequestClose={closeCancelModal}>
                    </ModalCancel>
                    <ModalTimer
                        atividades={atividades}
                        timesheetItemAtividade={timesheetItemAtividade}
                        isOpen={modalTimerIsOpen}
                        onAfterOpen={afterTimerOpenModal}
                        onRequestClose={closeTimerModal}>
                    </ModalTimer>
                    <ModalBilling
                        atividades={atividades}
                        isOpen={modalBillingIsOpen}
                        onAfterOpen={afterBillingOpenModal}
                        onRequestClose={closeBillingModal}>
                    </ModalBilling>
                    <ModalMeritocracy
                        atividades={atividades}
                        timesheetItemAtividade={timesheetItemAtividade}
                        isOpen={modalMeritocracyIsOpen}
                        onAfterOpen={afterMeritocracyOpenModal}
                        onRequestClose={closeMeritocracyModal}>
                    </ModalMeritocracy>
                    <ModalReview
                        atividades={atividades}
                        timesheetItemAtividade={timesheetItemAtividade}
                        isOpen={modalReviewIsOpen}
                        onAfterOpen={afterReviewOpenModal}
                        onRequestClose={closeReviewModal}>
                    </ModalReview>
                    <ModalNovoGrupoAtividade
                        timesheetAtividade={timesheetAtividade}
                        isOpen={modalNovoGrupoAtividadeIsOpen}
                        onAfterOpen={modalNovoGrupoAtividadeOpen}
                        timesheet={timesheet}
                        onRequestClose={closeNovoGrupoAtividadeModal}
                        peritos={peritosList}
                        selectedGrupoAtividade={selectedGrupoAtividade}
                    >
                    </ModalNovoGrupoAtividade>
                    <ModalGrupoDeAtividadesCancel
                        isOpen={modalGrupoAtividadeCancelIsOpen}
                        onAfterOpen={modalNovoGrupoAtividadeOpen}
                        onRequestClose={closeGrupoAtividadeCancelModal}
                        selectedGrupoAtividade={selectedGrupoAtividade}
                    >
                    </ModalGrupoDeAtividadesCancel>
                    <ModalMesclarTimesheet
                        timesheet={timesheet}
                        isOpen={modalMesclarTimesheetIsOpen}
                        setIsOpen={closeModalMesclarTimseheet}
                        onRequestClose={closeModalMesclarTimseheet}
                        loadPage={loadPage}
                    >
                    </ModalMesclarTimesheet>
                    <ModalEsclarecimento
                        timesheet={timesheet}
                        isOpen={modalEsclarecimentoIsOpen}
                        setIsOpen={closeModalEsclarecimento}
                        onRequestClose={closeModalEsclarecimento}
                        loadPage={loadPage}
                    >
                    </ModalEsclarecimento>
                    {
                        pendenciaDeAprovacao && (
                            <>
                                <ModalAprovacoesAprovar
                                    pendenciaDeAprovacao={pendenciaDeAprovacao}
                                    isOpen={modalAprovarIsOpen}
                                    setIsOpen={closeModalAprovar}
                                    onRequestClose={closeModalAprovar}
                                    loadTable={redirecionAposSucesso}
                                >
                                </ModalAprovacoesAprovar>
                                <ModalAprovacoesReprovar
                                    pendenciaDeAprovacao={pendenciaDeAprovacao}
                                    isOpen={modalReprovarIsOpen}
                                    setIsOpen={closeModalReprovar}
                                    onRequestClose={closeModalReprovar}
                                    loadTable={redirecionAposSucesso}
                                >
                                </ModalAprovacoesReprovar>
                                <ModalAprovacoesCancelar
                                    pendenciaDeAprovacao={pendenciaDeAprovacao}
                                    isOpen={modalCancelarIsOpen}
                                    setIsOpen={closeModalCancelar}
                                    onRequestClose={closeModalCancelar}
                                    loadTable={redirecionAposSucesso}
                                >
                                </ModalAprovacoesCancelar>
                                <ModalAprovacoesConcluir
                                    pendenciaDeAprovacao={pendenciaDeAprovacao}
                                    isOpen={modalConcluirIsOpen}
                                    setIsOpen={closeModalConcluir}
                                    onRequestClose={closeModalConcluir}
                                    loadTable={redirecionAposSucesso}
                                >
                                </ModalAprovacoesConcluir>
                            </>
                        )
                    }


                </StyledDefaultPage>
            </main>
        </section>
    );
};

export const TimeSheetDetalhesPage = (props) => {

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [timesheetItemAtividade, setTimesheetItemAtividade] = useState(defaultTimesheetItemAtividade);
    const [idTimesheetItemAtividade, setIdTimesheetItemAtividade] = useState(0);
    const [timesheetAtividade, setTimesheetAtividade] = useState(defaultTimesheetAtividade);
    const [valoresAtividades, setValoresAtividades] = useState([]);
    const [timesheet, setTimesheet] = useState(defaultTimesheet);
    const [showAtividades, setShowAtividades] = useState(false);
    var [dataLancamento, setdataLancamento] = useState(new Date());

    return (
        <TimeSheetDetalhesContext.Provider
            value={{
                timesheetItemAtividade, setTimesheetItemAtividade,
                idTimesheetItemAtividade, setIdTimesheetItemAtividade,
                timesheetAtividade, setTimesheetAtividade,
                valoresAtividades, setValoresAtividades,
                timesheet, setTimesheet,
                showAtividades, setShowAtividades, dataLancamento, setdataLancamento
            }}
        >
            <>
                {isMenuOpen ? (
                    <MenuPage
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                ) : (
                    <>
                        <Header
                            isMenuOpen={isMenuOpen}
                            setIsMenuOpen={setIsMenuOpen}
                        />
                        <TimeSheetDetalhes props={props} />

                    </>
                )}
            </>
        </TimeSheetDetalhesContext.Provider>
    );
};